<div class="container" [ngSwitch]="mode">
  <div *ngSwitchCase="'form'">
    <app-template [title]="'Invoice Printing'" style="padding-bottom: 400px">
      <div class="search" style="padding-top: 30px">
        <span class="form">
          <mat-form-field class="input">
            <mat-label>Start Date</mat-label>
            <input
              [(ngModel)]="sd"
              matInput
              [matDatepicker]="dob"
              (dateChange)="startDateChange($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dob"
            ></mat-datepicker-toggle>
            <mat-datepicker #dob></mat-datepicker>
          </mat-form-field>
        </span>
        <span class="form">
          <mat-form-field class="input">
            <mat-label>End Date</mat-label>
            <input
              [(ngModel)]="ed"
              matInput
              [matDatepicker]="end"
              (dateChange)="endDateChange($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="end"
            ></mat-datepicker-toggle>
            <mat-datepicker #end></mat-datepicker>
          </mat-form-field>
        </span>

        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input [(ngModel)]="nameSearch" matInput placeholder="" />
          </mat-form-field>
        </span>

        <div>
          <button
            (click)="searchEncounters()"
            style="margin-bottom: 30px; margin-left: 30px; margin-top: 20px"
            mat-raised-button
            color="primary"
          >
            Search
          </button>
        </div>
      </div>
      <div class="data" style="padding-bottom: 400px">
        <div *ngIf="isLoading" style="margin-top: 200px" class="spinner">
          <mat-spinner></mat-spinner>
        </div>
        <table *ngIf="!isLoading" style="width: 100%">
          <tr class="back">
            <th>Lab ID</th>
            <th>bill Date</th>
            <th>Name</th>
            <th>Amount</th>
            <th>Amount Paid</th>
            <th>Refunded Amount</th>
            <th>Amount Outstanding</th>
            <th>
              <!-- <button  mat-raised-button color="basic">
                            Clear All
                          </button> -->
            </th>
          </tr>
          <tr
            class="td"
            *ngFor="let item of encounters"
            style="cursor: pointer"
          >
            <td>{{ item.Bill_ID }}</td>
            <td>
              <div>{{ item.billDate | date }}</div>
              <div style="color: red">
                {{ item.billDate | date : "mediumTime" }}
              </div>
            </td>
            <td>{{ item.patientName }}</td>
            <td>{{ item.totalAmount | currency : "&#8358;" }}</td>
            <td>{{ item.amountPaid | currency : "&#8358;" }}</td>
            <td>{{ item.refundAmount | currency : "&#8358;" }}</td>
            <td>{{ item.amountOutstanding | currency : "&#8358;" }}</td>
            <td>
              <div class="dropdown">
                <button class="dropbtn" mat-raised-button>Actions</button>
                <div class="dropdown-content">
                  <a class="dropdown-item" (click)="addRecord(item)">Select</a>
                  <a class="dropdown-item" (click)="editBill(item)">Edit</a>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </app-template>
  </div>
  <div class="receipt" *ngSwitchCase="'rec'">
    <app-template
      [title]="'Print Invoice'"
      style="z-index: -3; padding-bottom: 500px"
    >
      <div class="inner">
        <button mat-raised-button color="primary" (click)="printResult()">
          Print
        </button>
        <button
          (click)="back()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Back
        </button>

        <div *ngIf="recLoad" style="margin-top: 50px" class="spinner">
          <mat-spinner></mat-spinner>
        </div>
        <!-- <div *ngIf="!recLoad" class="return" id="receipt" style=" margin-left: 50px; margin-bottom: 100px;margin-top: 70px; position: relative; z-index: 2;" [innerHTML]="receipt"></div> -->
        <div class="invoice" style="width: 100%">
          <div *ngIf="reLoad" style="width: 200px; margin: 100px auto">
            <mat-spinner></mat-spinner>
          </div>
          <div id="receipt" class="all" style="width: 400px" *ngIf="!reLoad">
            <div class="top" style="font-size: 16px">
              Everight Diagnostic & Laboratory Service LTD 
              <!-- Abuja Branch 2 Fez Street; 08155515100, 08108484623 -->
              {{ appversion.branch.name }} {{ appversion.branch.address }} {{ appversion.branch.contact }}
             </div>
            <div class="name" style="font-size: 23px; font-weight: 700">
              Cash Invoice
            </div>
            <div class="body">
              <table>
                <tr style="font-size: 20px">
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Bill No.</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{ detail!.bill_no }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Name</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{ detail!.patientName }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Date and Time</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{ detail!.billDate | date:'yyyy-MM-dd HH:mm' }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Date of Birth</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{ detail!.date_of_birth | date }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Age/Gender</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value"
                      >{{ detail!.patient_age }}/{{
                        detail!.patient_gender
                      }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Mobile No</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{ detail!.patient_phone }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Ref DR.</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{ detail!.referred_doctor }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">SOC</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">
                      {{ detail?.soc_name || "SOC-ID - " + (detail?.soc_id || "") }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">The sum of</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">Zero Naira Only</span>
                  </td>
                </tr>
              </table>
              Being Payment for
              <hr />
             <div *ngFor="let dept of departmentNames">
                <h4>{{ dept }}</h4>
              <div *ngFor="let service of groupedServices[dept]">
                {{ service.service_name }} ({{ service.sample_id }})
              </div>
              </div>
              <table style="font-size: 20px">
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Bill Amount</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{
                      detail!.totalAmount | currency : "&#8358;"
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Refund Amount</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{
                      detail!.refundAmount | currency : "&#8358;"
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Advance Amount</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">0.00</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Received Amount</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{
                      detail!.amountPaid | currency : "&#8358;"
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var">Balance Amount</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{
                      detail!.amountOutstanding | currency : "&#8358;"
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var" style="font-weight: 700">Issued By</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{ detail!.authorName }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <b class="var" style="font-weight: 700">Print Timestamp</b>
                  </td>
                  <td style="border: 0px; padding: 0px; font-size: 16px">
                    <span class="value">{{ currentDate() | date:'yyyy-MM-dd HH:mm' }}</span>
                  </td>
                </tr>
              </table>
              <div style="margin-top: 20px">Thank you</div>
              <div>
                Please bring your receipt on the date of result collection The
                receipt is only valid with the stamp & signature of the cashier.
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-template>
  </div>
</div>
